import styled from 'styled-components';

export const Message = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  text-align: center;
  color: ${({ theme, $color }) => $color || theme.colors.semantic.text.inverse};
`;
